import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../store/theme.actions';
import { ValidarProcesso } from './ValidarProcesso';
import ValidarProcessoProvider from '../../store/ValidarProcesso/ValidarProcessoProvider';

function ValidarProcessoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Validação de Processos'));
  return (
    <ValidarProcessoProvider>
      <ValidarProcesso />
    </ValidarProcessoProvider>
  );
}

export default withTokenInterceptor(ValidarProcessoPage);
